import styled from 'styled-components'

export const Form = styled.form`
    display: flex;
    flex-direction: column;
`
export const RowItem = styled.div<{ singleItem?: boolean }>`
    width: ${({ singleItem }) => (singleItem ? '100%' : '50%')};
`

export const Row = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 20px;

    @media screen and (max-width: 990px) {
        flex-direction: column;

        ${RowItem} {
            width: 100%;
        }
    }
`

export const Select = styled.select<{ error?: boolean }>`
    border: 1px solid ${({ error }) => (error ? '#df0017' : '#ccc')};
`
